<template>
    <div id="dialog-delete-apiary-widget-component">
        <v-dialog v-model="is_dialog_delete_apiary_open" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="text-uppercase font-weight-bold error--text">
                        {{ $t('global_apiary.delete_apiary') }}
                    </span>
                </v-card-title>

                <v-card-text class="font-weight-medium pb-0 pt-1">
                    <span>
                        {{ $t('global_apiary.confirm_delete_apiary') }} <strong>{{ apiary.name }}</strong> ?
                    </span>
                </v-card-text>

                <v-card-actions class="justify-end">
                    <v-btn text @click="is_dialog_delete_apiary_open = false">
                        <span class="font-weight-bold">{{ $t('global.cancel') }}</span>
                    </v-btn>

                    <v-btn :loading="loading_delete_apiary" class="font-weight-bold btn-error-loader"
                           color="error" text
                           @click="deleteApiary()"
                    >
                        <span class="error--text">{{ $t('global.delete') }}</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import ApiaryRepository from '@/repositories/ApiaryRepository'

export default {
    name: 'DeleteApiaryFormDialogComponent',
    data() {
        return {
            is_dialog_delete_apiary_open: false,
            apiary: {},
            loading_delete_apiary: false,
        }
    },
    methods: {
        openDialogDeleteApiary(apiary) {
            this.apiary = apiary
            this.is_dialog_delete_apiary_open = true
        },

        deleteApiary() {
            this.loading_delete_apiary = true

            ApiaryRepository.deleteApiary(this.apiary.id_apiary).then(() => {
                this.showSnackbar('success', this.$t('global_apiary.apiary_deleted'))
                this.$emit('apiaryDeleted')
                this.is_dialog_delete_apiary_open = false
            }).catch(error => {
                this.manageError(error)
            }).finally(() => {
                this.loading_delete_apiary = false
            })
        }
    }
}
</script>